import { JSX } from "react"
import { NavigateFunction, useNavigate } from "react-router"

import Button from "../../Component/Button"
import Game from "../../Model/Game"
import formatTime from "../../util/formatTime"

import "./menu.css"

type Props = {
  ref: HTMLElement | null
  game: Game
  onRestart: () => void
  daily?: boolean
}

export default function MenuView({
  ref,
  game,
  onRestart,
  daily,
}: Props): JSX.Element {
  const navigate: NavigateFunction = useNavigate()

  const toggleFullscreen: () => void = (): void => {
    if (document.fullscreenElement) {
      document.exitFullscreen()

      return
    }

    ref?.requestFullscreen()
  }

  const backToMainMenu: () => void = (): void => {
    navigate("/")
  }

  return (
    <div id="menu">
      <span id="timer">{formatTime(game.time)}</span>
      <Button onClick={toggleFullscreen}>Fullscreen</Button>
      {!daily && <Button onClick={onRestart}>Restart</Button>}
      <Button onClick={backToMainMenu}>Exit</Button>
      {!daily && (
        <>
          <span>Seed</span>
          <span>{game.id}</span>
        </>
      )}
    </div>
  )
}
